export default __webpack_public_path__ + "static/bg_img-2afed602c01f41b77fd96bc841c0894b.webp";